import e, { useState as r } from "react";
import { componentName as t } from "../../../utils/bem/index.js";
import "../../forms/InputText/InputText.js";
import { InputTextField as a } from "../../forms/InputText/InputTextField.js";
import { Button as n } from "../../buttons/Button/Button.js";
import { Banner as o } from "../../alerts/Banner/Banner.js";
import { CheckBox as l } from "../../forms/Checkbox/Checkbox.js";
import { KASEYA as s } from "../../../constants/kaseya.js";
import { t as m } from "../../../i18/index.js";
function i(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, a = Array(r); t < r; t++) a[t] = e[t];
  return a;
}
function c(c) {
  var u,
    b = t("login", c.className, {}),
    f = c.forgotPasswordLink,
    p = c.helpAndSupportLink,
    g = c.loginWithItcLink,
    d = c.usernameError,
    _ = c.passwordError,
    y = c.onLogin,
    E = c.showSubdomain,
    v = c.companyLogo,
    h = c.errorMessage,
    N = c.onCloseErrorMessage,
    w = c.showRememberMe,
    j = c.showMfa,
    x = c.brandLogo,
    I = c.brandUrl,
    O = function (e) {
      if (Array.isArray(e)) return e;
    }(u = r(!1)) || function (e, r) {
      var t,
        a,
        n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var o = [],
          l = !0,
          s = !1;
        try {
          for (n = n.call(e); !(l = (t = n.next()).done) && (o.push(t.value), !r || o.length !== r); l = !0);
        } catch (e) {
          s = !0, a = e;
        } finally {
          try {
            l || null == n.return || n.return();
          } finally {
            if (s) throw a;
          }
        }
        return o;
      }
    }(u, 2) || function (e, r) {
      if (e) {
        if ("string" == typeof e) return i(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        if ("Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t) return Array.from(t);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
      }
    }(u, 2) || function () {
      throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }(),
    k = O[0],
    L = O[1];
  return e.createElement("div", {
    className: b
  }, e.createElement("div", {
    className: "public__background-container-bottom"
  }), e.createElement("div", {
    className: "public__background-container-top"
  }), e.createElement("div", {
    className: "public__logos-row"
  }, e.createElement("a", {
    tabIndex: 1,
    href: I
  }, e.createElement("img", {
    src: x
  }))), e.createElement("form", {
    onSubmit: function onSubmit(e) {
      var r;
      e.preventDefault(), y(function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = null != arguments[r] ? arguments[r] : {},
            a = Object.keys(t);
          "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          }))), a.forEach(function (r) {
            var a;
            a = t[r], r in e ? Object.defineProperty(e, r, {
              value: a,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[r] = a;
          });
        }
        return e;
      }({
        username: (r = new FormData(e.target)).get("username"),
        password: r.get("password"),
        rememberMe: k
      }, E && {
        subdomain: r.get("subdomain")
      }, j && {
        mfaCode: r.get("mfa")
      }));
    },
    className: "login__panel"
  }, e.createElement("img", {
    className: "public__company-logo",
    src: v
  }), h && e.createElement(o, {
    className: "login__error-banner",
    type: "error",
    onClose: N
  }, h), E && e.createElement(a, {
    className: "login__subdomain",
    autoFocus: !j,
    name: "subdomain",
    tabIndex: 1,
    label: m("subdomain")
  }), e.createElement(a, {
    autoFocus: !E && !j,
    errorMessage: d,
    tabIndex: 1,
    className: "login__username",
    name: "username",
    label: m("email")
  }), e.createElement("div", {
    className: "login__password-container"
  }, f && e.createElement("a", {
    className: "login__forgot-password",
    href: f
  }, m("forgot-password")), e.createElement(a, {
    errorMessage: _,
    type: "password",
    tabIndex: 1,
    className: "login__password",
    name: "password",
    label: m("password")
  })), j && e.createElement(a, {
    className: "login__mfa",
    autoFocus: !0,
    name: "mfa",
    tabIndex: 1,
    label: m("mfa-code")
  }), w && e.createElement(l, {
    className: "login__remember-me",
    value: k,
    onChange: function onChange(e) {
      return L(e);
    },
    name: "rememberMe",
    fieldLabel: m("remember-me")
  }), e.createElement(n, {
    className: "login__button",
    type: "submit",
    label: m("log-in"),
    variant: "accent",
    size: "large"
  }), g && e.createElement(e.Fragment, null, e.createElement("div", {
    className: "login__sso-divider"
  }, m("or")), e.createElement("a", {
    href: g
  }, e.createElement(n, {
    className: "login-itc__button",
    type: "button",
    iconPlacement: "before",
    size: "large"
  }, e.createElement("span", {
    className: "login-itc__button-inner"
  }, e.createElement("div", {
    className: "login__itc-icon"
  }), m("log-in-with-itc")))))), e.createElement("div", {
    className: "public__footer"
  }, e.createElement("div", {
    className: "public__footer-logo"
  }, e.createElement("div", {
    className: "public__footer-logo-img"
  })), e.createElement("a", {
    className: "public__footer-link",
    target: "_blank",
    href: p
  }, m("help-and-support")), " | ", " ", s.COPYRIGHT));
}
c.defaultProps = {
  brandUrl: s.URL,
  brandLogo: s.LOGO
}, c.displayName = c;
export { c as Login };